import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { Response } from '@angular/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { RemitoFilter } from '../components/administracion/remitos/remitos-home/remitos-home.component';
import * as moment from 'moment';
import { ABMRolesService } from '@services/abm-roles-service';
import {FormSelectItem, RemitoAcopio} from '../components';
import { FileSaverService } from '@services/file-saver-service';
import {from} from 'rxjs/observable/from';
import {Provincia} from '@services/provincias-service';

export const remitosFiltersName = {
  fecha: 'Fecha',
  numLegal: 'Número de Remito',
  acopio: 'Acopio',
  cliente: 'Cliente',
  centroEmisor: 'Centro Emisor',
};

@Injectable()
export class RemitosService {
  private _remitosValidated: BehaviorSubject<RemitoPermiso> =
    new BehaviorSubject<RemitoPermiso>({
      AcopioPermitido: false,
      Admin: false,
    });
  public remitosValidated: Observable<RemitoPermiso> =
    this._remitosValidated.asObservable();

  acopiosAll: RemitoAcopio[] = [];

  private acopiosSubject: BehaviorSubject<RemitoAcopio[]> = new BehaviorSubject<
    RemitoAcopio[]
  >([]);
  public $acopiosAll = this.acopiosSubject.asObservable();
  public motivoGeneracion = '';
  public dialogWasOpen = false;
  constructor(
    private httpClient: HttpClient,
    private abmService: ABMRolesService,
    private fileSaverService: FileSaverService
  ) {
    const sub = this.abmService.getAcopios().subscribe((x) => {
      if (x && x.length) {
        const val = x.map((y) => ({ Nombre: y.AcopioNombre, IdAcopio: y.Id }));
        this.acopiosAll = val;
        this.acopiosSubject.next(val);
      }
      sub.unsubscribe();
    });
  }

  validateRemitos(): void {
    // validamos si el usuario tiene acopios autorizados
    this.verificarAcopios().subscribe((res) => {
      if (typeof res === 'boolean') {
        const obj = { ...this._remitosValidated.getValue() };
        obj.AcopioPermitido = res;
        this._remitosValidated.next(obj);
      }
    });
    // validamos si el usuario es administrador
    this.verificarAdmin().subscribe((res) => {
      if (typeof res === 'boolean') {
        const obj = { ...this._remitosValidated.getValue() };
        obj.Admin = res;
        this._remitosValidated.next(obj);
      }
    });
  }

  private verificarAcopios(): Observable<any> {
    return this.httpClient
      .get('/api/remito/autorizado')
      .map((response: Response) => {
        if (response) {
          return response.json().ResponseData;
        }
      });
  }

  private verificarAdmin(): Observable<any> {
    return this.httpClient
      .get('/api/remito/usuario')
      .map((response: Response) => {
        if (response) {
          return response.json().ResponseData;
        }
      });
  }

  public acopiosPermitidos(): Observable<any> {
    return this.httpClient
      .get('/api/remito/acopiosAutorizados')
      .map((response: Response) => {
        if (response) {
          return response.json().ResponseData as {
            Nombre: string;
            IdAcopio: number;
          }[];
        }
      });
  }

  public autorizarAcopios(payload): Observable<any> {
    return this.httpClient
      .post('/api/remito/autorizar', payload)
      .map((response: Response) => {
        if (response) {
          return response.json().ResponseData;
        }
      });
  }

  public quitarAutorizacion(payload): Observable<any> {
    return this.httpClient
      .post('/api/remito/quitarAutorizacion', payload)
      .map((response: Response) => {
        if (response) {
          return response.json().ResponseData;
        }
      });
  }

  public getRemito(id: number): Observable<any> {
    let params = new URLSearchParams(
      Object({ numeroLegal: id.toString() })
    ).toString();
    return this.httpClient
      .get(`/api/remito/detalle?${params}`)
      .map((response: Response) => {
        if (response) {
          return response.json().ResponseData as InsumoRemitoViewModel[];
        }
      });
  }

  public getPartidaRemito(id: number): Observable<PartidaRemitoViewModel[]> {
    const url = '/api/remito/detallePartida';
    let params = new URLSearchParams(
      Object({ numeroLegal: id.toString() })
    ).toString();

    return this.httpClient.get(`${url}?${params}`).map((response: Response) => {
      if (response) {
        let partidasRemito: PartidaRemitoViewModel[] =
          response.json().ResponseData;
        return partidasRemito;
      }
    });
  }

  // este EP se puede usar para 2 casos, obtener uno u obtener la lista, depende de si se filtra por numero legal
  public getListaRemitos(filtros: RemitoFilter[]): Observable<any> {
    const url = '/api/remito/cabecera';
    const cli = filtros.find(
      (x) => x.name === remitosFiltersName.cliente
    ).value;
    // const numLegal = filtros.find(x => x.name === remitosFiltersName.numLegal).value;
    let remitoFilter = {
      fecha: moment(
        filtros.find((x) => x.name === remitosFiltersName.fecha).value
      ).unix(), // Se incorporan 3 horas para compensar la diferencia con el BE
      acopio: filtros
        .find((x) => x.name === remitosFiltersName.acopio)
        .value.Id.toString(),
      centroEmisor: filtros
        .find((x) => x.name === remitosFiltersName.centroEmisor)
        .value.Id.toString(),
      numeroLegal: '',
      // numeroLegal: numLegal ? numLegal.toString() : '',
      clienteId: cli ? cli.Id.toString() : '',
    };
    let params = new URLSearchParams(Object(remitoFilter)).toString();
    return this.httpClient.get(`${url}?${params}`).map((response: Response) => {
      if (response) {
        let remitos: CabeceraRemitoViewModel[] = response.json().ResponseData;
        // Ajuste de hora
        remitos.forEach((remito) => {
          remito.FechaRemito = moment(remito.FechaRemito).valueOf(); // Obtener estampa en milisegundos para usar en Angular
        });
        return remitos;
      }
    });
  }

  public getCabeceraRemito(id: number): Observable<CabeceraRemitoViewModel> {
    const url = '/api/remito/cabecera';

    return this.httpClient.get(`${url}/${id}`).map((response: Response) => {
      if (response) {
        let cabeceraRemito: CabeceraRemitoViewModel =
          response.json().ResponseData[0];
        // usamos moment para pasar a milisegundos y añadimos 3 horas para compensar lo que nos trae el back
        cabeceraRemito.FechaRemito = moment(cabeceraRemito.FechaRemito * 1000)
          .add(3, 'h')
          .valueOf();
        return cabeceraRemito;
      }
    });
  }

  public getCentrosEmisores(idAcopio: number): Observable<any> {
    const url = '/api/remito/centroEmisor';
    let params = `?acopioId=${idAcopio}&conSucursales=true`;
    return this.httpClient.get(url + params).map((response: Response) => {
      if (response) {
        return response.json().ResponseData;
      }
    });
  }

  public getNextNumeroRemito(centroEmisor: number): Observable<any> {
    const url = '/api/remito/numero';
    let params = `?centroEmisor=${centroEmisor}`;
    return this.httpClient.get(url + params).map((response: Response) => {
      if (response) {
        return response.json().ResponseData;
      }
    });
  }

  public getChoferByCuit(cuit: string) {
    const cleanCuit: string = cuit.replace(/-/g, '');
    const url = '/api/remito/chofer';
    const params = new URLSearchParams(
      Object({ nombre: '', cuit: cleanCuit })
    ).toString();
    return this.httpClient.get(`${url}?${params}`).map((response: Response) => {
      if (response) {
        let choferes: ChoferViewModel[] = response.json().ResponseData;
        return choferes;
      }
    });
  }

  public postRemito(remitoForm: any): Observable<any> {
    let payload: Remito = this.mapRemito(remitoForm);
    return this.httpClient
      .post('/api/remito/crear', payload)
      .map((response: Response) => {
        if (response) {
          return response.json().ResponseData;
        }
      });
  }

  private mapRemito(remitoForm: any): Remito {
    const cliente = JSON.parse(remitoForm.cliente.RawValue);
    let remito: Remito = {
      // Remito
      Oficina: remitoForm.oficinaComercial.Id,
      Sucursal: remitoForm.sucursalComercial.Id,
      CentroEmisor: remitoForm.centroEmisor.toString(),
      NumeroComprobante: remitoForm.numeroComprobante.toString(),
      FechaRemito: moment().unix(),
      Observacion: remitoForm.observaciones,
      // Origen
      Provincia: this.addInitialZero((JSON.parse(remitoForm.provinciaOrigen.RawValue) as Provincia).Pro_ID),
      CodigoPostal: remitoForm.codPostalOrigen,
      // Destino
      ProvinciaDestino: this.addInitialZero((JSON.parse(remitoForm.provinciaDestino.RawValue) as Provincia).Pro_ID),
      CodigoPostalDestino: remitoForm.codPostalDestino,
      Direccion: remitoForm.direccionEntrega,
      // Cliente
      Cliente: cliente.An8,
      ProvinciaCliente: this.addInitialZero((JSON.parse(remitoForm.provinciaCliente.RawValue) as Provincia).Pro_ID),
      PostalCode: cliente.CodigoPostalId,
      // Chofer
      ChoferId: remitoForm.idChofer,
      // Transportista
      Transportista: remitoForm.idTransportista,
      // Vehiculo
      VehiculoPVEH: remitoForm.vehiculo,
      Acoplado: remitoForm.acoplado,
      Deposito: remitoForm.unidadDeNegocio,
      Motivo: this.motivoGeneracion,
      // Insumos
      Insumos: remitoForm.productos.map((producto) => {
        let insumo: Insumo = {
          Cantidad: producto.cantidad,
          CantidadPeso: 0, // ???
          Descripcion: producto.Descripcion,
          DescripcionAdicional: producto.Descripcion, // ???
          Insumo: producto.Nombre,
          Observaciones: '', // ???
          UnidadMedida: producto.UnidadMedida,
          UnidadMedida2: producto.UnidadMedida, // ???
        };
        return insumo;
      }),
      NroCAI: remitoForm.cai,
      FechaDesdeCAI: remitoForm.caiDesde,
      FechaHastaCAI: remitoForm.caiHasta,
    };
    return remito;
  }

  private addInitialZero(val: number): string {
    const valStr = val.toString();
    return valStr.length === 1 ? `0${val}` : valStr;
  }

  public imprimirRemito(id: string): Observable<any> {
    return this.httpClient
      .getFiles(`/api/remito/get-attachment/${id}`)
      .map((response: Response) => {
        let errors = response.headers.get('errors');
        if(errors){
          return errors;
        }
        if (response) {
          return this.fileSaverService.SaveToFileSystem(response);
        }
      });
  }

  public getOficina(idOficina: number) {
    return this.httpClient
      .get(`/api/remito/oficina/${idOficina}`)
      .map((response: Response) => {
        if (response) {
          let oficina: Oficina = response.json().ResponseData;
          return oficina;
        }
      });
  }

  public getMotivo(idRemito: number) {
    return this.httpClient
      .get(`/api/remito/motivo/${idRemito}`)
      .map((response: Response) => {
        if (response) {
          return response.json().motivo;
        }
      });
  }

  mapCentroEmisor(centroEmisor: any) {
    let centro: CentroEmisor = {
      idAcopio: Number(centroEmisor.AcopioId),
      idAcopioParent: Number(centroEmisor.AcopioParentId),
      idCentroEmisor: String(centroEmisor.CentroEmisorId),
      unidadNegocio: String(centroEmisor.UnidadDeNegocio),
    };
    return centro;
  }

  public getNumeroCAI(idCentroEmisor: string) {
    return this.httpClient
      .get(`/api/remito/${idCentroEmisor}/numero-cai`)
      .map((response) => {
        if (response) {
          return response.json().Data;
        }
      });
  }
}

export interface AcopioNuevo {
  Id: number;
  AcopioNombre: string;
}

export interface Oficina {
  Id: number;
  Nombre: string;
  IdSucursal: number;
  SucursalesComerciales: any;
}
export interface CentroEmisor {
  idAcopio: number;
  idAcopioParent: number;
  idCentroEmisor: string;
  unidadNegocio: string;
}

export interface RemitoPermiso {
  AcopioPermitido: boolean;
  Admin: boolean;
}

export interface ChoferViewModel {
  ChoferID: number;
  Nombre: string;
  TAX: string;
  Eliminado: string;
  Bloqueado: string;
}

export interface ClienteCUITViewModel {
  AN8: number;
  Numero: string;
  Nombre: string;
  Domicilio: string;
  CodPostal: string;
  Localidad: string;
  CondIVA: string;
}

export interface Remito {
  CentroEmisor: string;
  NumeroComprobante: string;
  Oficina: number;
  Sucursal: number;
  CodigoPostalDestino: string;
  ProvinciaDestino: string;
  FechaRemito: number; // La fecha en formato Unix
  Cliente: number;
  PostalCode: string;
  CodigoPostal: string;
  ChoferId: string;
  Transportista: string;
  VehiculoPVEH: string;
  Acoplado: string;
  Deposito: string;
  Provincia: string;
  Direccion: string;
  ProvinciaCliente: string;
  Observacion: string;
  Motivo: string;
  Insumos: Insumo[];
  NroCAI: string,
  FechaDesdeCAI: string,
  FechaHastaCAI: string,
}

export interface Insumo {
  Insumo: string;
  Descripcion: string;
  DescripcionAdicional: string;
  Cantidad: number;
  CantidadPeso: number;
  UnidadMedida: string;
  UnidadMedida2: string;
  Observaciones: string;
}

export interface InsumoRemitoViewModel {
  KCO: string;
  Tipo: string;
  Documento: number;
  NumeroRenglon: number;
  CodigoInsumo: string;
  Descripcion: string;
  Descripcion2: string;
  UnidadMedida: string;
  Cantidad: number;
}

export interface CabeceraRemitoViewModel {
  DocumentoJDE: number;
  Compania: string;
  FechaRemito: number;
  Tipo: string;
  CentroEmisor: string;
  NumeroComprobante: string;
  LetraComprobante: string;
  Deposito: string;
  NumeroLegal: string;
  Comp: string;
  Oficina: string;
  Sucursal: string;
  CodigoPostal: string;
  Provincia: string;
  Cliente: string;
  Nombre: string;
  Direccion: string;
  PostalCode: string;
  SituacionIVA: string;
  CUIT: string;
  NroIIBB: string;
  Transportista: number;
  SituacionIVATransportista: string;
  CUITTransportista: string;
  ChoferId: number;
  Patente: string;
  Acoplado: string;
  CodigoPostalDestino: string;
  ProvinciaDestino: string;
  NroCAI: string;
  FechaDesdeCAI: string;
  FechaHastaCAI: string;
  ABDireccionEntrega: string;
  VehiculoPVEH: string;
  ProvinciaCliente: string;
  Observacion: string;
  Insumos?: any; // Vienen en el detalle del remito
}

export interface InsumoRemitoViewModel {
  KCO: string;
  Tipo: string;
  Documento: number;
  NumeroRenglon: number;
  CodigoInsumo: string;
  Descripcion: string;
  Descripcion2: string;
  UnidadMedida: string;
  Cantidad: number;
}

export interface PartidaRemitoViewModel {
  KCO: string;
  Tipo: string;
  Documento: number;
  NumeroRenglon: number;
  CodigoInsumo: string;
  Descripcion: string;
  Descripcion2: string;
  UnidadDeMedida: string;
  Lote: string;
  Vencimiento: string;
  Cantidad: number;
}

export interface InsumoRemitoViewModel {
  KCO: string;
  Tipo: string;
  Documento: number;
  NumeroRenglon: number;
  CodigoInsumo: string;
  Descripcion: string;
  Descripcion2: string;
  UnidadMedida: string;
  Cantidad: number;
}

export let errorsCodes = {
  REM001: 'Cabecera',
  REM002: 'Detalle',
  REM003: 'Numero de CAI',
  REM004: 'Transportista',
  REM005: 'Chofer',
  REM006: 'Oficina',
  REM007: 'Cliente',
  REM008: 'Partidas',
  REM009: 'Numero de viaje',
  REM010: 'Peligrosidad de insumos'
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/remitos-service.ts